import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {EnumPaymentProcessorModel} from '../models/enum-payment-processor.model';
import {CfgArPaymentProcessorDeviceModel} from '../../../models/accountsReceivable/cfg-ar-payment-processor-device.model';
import {CfgARPaymentMethodModel} from '../../../models/accountsReceivable/cfg-ar-payment-method';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodConfigurationService {
  constructor(private http: HttpClient) {
  }

  getClients(): Observable<any[]> {
    let url: string;
    const method: string = 'payment-processor-configuration/tdo-clients';
    url = environment.TDOurl + method;
    return this.http.get<any>(url);
  }

  getClientLocations(tdocid: string): Observable<any[]> {
    let url: string;
    const method: string = 'payment-processor-configuration/tdo-clients-locations/' + tdocid;
    url = environment.TDOurl + method;
    return this.http.get<any>(url);
  }

  getPaymentMethodList(locid: string): Observable<CfgARPaymentMethodModel[]> {
    let url: string;
    const method: string = 'payment-method-configuration/payment-method-by-location/' + locid;
    url = environment.TDOurl + method;
    return this.http.get<CfgARPaymentMethodModel[]>(url);
  }

  getPaymentProcessorDevice(paymentDeviceID: string): Observable<CfgArPaymentProcessorDeviceModel> {
    let url: string;
    const method: string = `payment-processor-configuration/payment-processor-device/${paymentDeviceID}`;
    url = environment.TDOurl + method;
    return this.http.get<CfgArPaymentProcessorDeviceModel>(url);
  }

  savePaymentMethod(method: CfgARPaymentMethodModel): Observable<CfgARPaymentMethodModel> {
    return this.http.post<CfgARPaymentMethodModel>('/api/payment-method-configuration/save-payment-method/', method);
  }

  getEnumValidValueItemsByValidValueName(ValidValueName: string): Observable<EnumPaymentProcessorModel[]> {
    return this.http.get<EnumPaymentProcessorModel[]>('/api/payment-processor-configuration/payment-processor-types/');
  }

  clearPaymentMethods(locationId: string): Observable<any> {
    const url = `${environment.TDOurl}payment-method-configuration/clear-payment-methods/${locationId}`;
    return this.http.post(url, {});
  }   
}
